import React, { ChangeEvent } from "react";

import Modal from "components/Modal";
import { Visibility } from "components/Visibility";
import { Column } from "components/Layout/Grid";
import TextArea from "components/TextArea";
import Text from "components/Text";

import { ModalRecuseProps } from "./interface";

import * as Styled from './styles';

export const ModalRecuse: React.FC<ModalRecuseProps> = ({
  isOpen,
  onClose,
  onSubmit,
  internalComment,
  handleInternalComment,
  errorRequest
}) => (
  <Visibility visible={isOpen}>
    <Modal title="Recusar processo" showCloseButton onCloseAction={onClose} className='p-5' width={'500px'} minWidth='min-w-20'>
      <Column className="mt-5">
        <p className='pb-1'>Motivo da recusa *</p>
        <TextArea
          className="w-100"
          autoFocus
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => handleInternalComment(e.target.value)}
          placeholder="Mensagem"
          required
          minLength={5}
          value={internalComment}
          style={{ height: 130 }}
        />
        <Visibility visible={!!errorRequest.isErrorField}>
          <p className='color-danger'>{errorRequest.message}</p>
        </Visibility>
        <Styled.ButtonRefuse
          width={160}
          style={{ margin: '0 auto', marginTop: 20 }}
          onClick={() => onSubmit(false)}
        >
          <Text className="color-primary font-bold px-1">Recusar Processo</Text>
        </Styled.ButtonRefuse>
      </Column>
    </Modal>
  </Visibility>
);